import {ZIDX, ZIDXPage} from "../standaloneLibrary.js";
import jQuery from "jquery";
import {AIChatBox, AIChatBoxConfig} from "./AIChatBox.js";
import {RAGResults} from "./RAGResults.js";
import {acceptParentMessage, postToParent} from "../IframeParentOrigin.js";
const $ = jQuery;

export class ZIDXRAGChat implements ZIDXPage {
    zidx: ZIDX;
    private aiBotId: string = "";
    private aiSessionId: string | null = null;
    private aiChatBox: AIChatBox | null = null;
    private pageContainer: HTMLElement | null = null;

    constructor(zidx: ZIDX) {
        this.zidx = zidx;
    }

    getPageClass() {
        return "zidxRAGChatContainer";
    }

    render() {
        console.log("RAGChat");
        const self = this;
        const container = $("." + this.getPageClass() + ".zidxPageActive", this.zidx.peakidxShadowRoot)[0];
        const lastURL = container ? (container.getAttribute("data-last-url") || "") : "";
        if (container && !/[?&]sessionId=/.test(lastURL)) {
            // a form may have been redirected here: ask who we are (visitor session scoped), then start the chat
            this.loadFormHandoff().then((handoff) => {
                if (!container.isConnected) return;
                self.startChat(handoff);
            });
            return;
        }
        this.startChat(null);
    }

    /** Pending form hand-off of this visitor (label, localized banner, original message), or null. Never throws. */
    private async loadFormHandoff(): Promise<any | null> {
        try {
            const res = await fetch(this.zidx.options.selectedSiteDomain + "/chat-form-handoff/", {credentials: "include"});
            const json = await res.json();
            if (!json.success || !json.data) return null;
            const data = typeof json.data == "string" ? JSON.parse(json.data) : json.data;
            return data && data.pending ? data : null;
        } catch (e) {
            return null;
        }
    }

    /** Banner above the chat that says why the visitor is here. */
    private showHandoffBanner(chatEmbed: HTMLElement, text: string) {
        if (!text) return;
        const banner = document.createElement("div");
        banner.className = "idx-ai-handoff-banner";
        banner.setAttribute("role", "status");
        banner.textContent = text;
        chatEmbed.parentElement!.insertBefore(banner, chatEmbed);
    }

    private startChat(handoff: any | null) {
        const self = this;
        const pageContainer = $("." + this.getPageClass() + ".zidxPageActive", this.zidx.peakidxShadowRoot)[0];
        if (!pageContainer) return;
        this.pageContainer = pageContainer;
        const pageMarginContainer = $("." + this.getPageClass() + ".zidxPageActive .zidxPageMargin", this.zidx.peakidxShadowRoot)[0];
        if (!pageMarginContainer) return;

        this.aiBotId = pageMarginContainer.getAttribute("data-ai-bot-id") || "";
        if (!this.aiBotId){
            console.log("aiBotId missing");
            return;
        }

        const chatEmbed = $("." + this.getPageClass() + ".zidxPageActive .aifcChatEmbed", this.zidx.peakidxShadowRoot)[0];
        if (!chatEmbed) {
            console.log("Chat Embed Missing");
            return;
        }

        const restoreSessionId = this.getSessionIdFromContainer(pageContainer);

        const config = new AIChatBoxConfig();
        const customPlaceholder = pageMarginContainer.getAttribute("data-placeholder") || "";
        if (customPlaceholder) {
            config.placeholder = customPlaceholder;
        }
        const skinned = pageMarginContainer.getAttribute("data-idx-ai-skin") === "1";
        config.clearPlaceholderAfterFirstReply = skinned;
        if (skinned) {
            this.initEmbedCloseHandshake(pageContainer);
        }
        // a pending form hand-off sends the original message as the first turn; do not also send an embed's ?prompt=
        const autoSend = !restoreSessionId && handoff && handoff.firstTurn && handoff.message ? String(handoff.message) : "";
        if (autoSend) config.suppressUrlPrompt = true;
        if (handoff && !restoreSessionId) this.showHandoffBanner(chatEmbed as HTMLElement, String(handoff.banner || ""));
        config.aiEndPointURL = "/rag-chat-stream/";
        config.aiBotId=parseInt(this.aiBotId)||0;
        config.feedbackURL = "/ai-chat-feedback/";
        config.extraQueryParams = "&ai_bot_id=" + encodeURIComponent(this.aiBotId);
        if (pageMarginContainer.getAttribute("data-debug") === "1") {
            config.extraQueryParams += "&debug=1";
        }

        // Triggers AIChatBox.loadSessionHistory() -> renderHistoryMessages() -> onHistoryLoaded
        if (restoreSessionId) {
            config.initialSessionId = restoreSessionId;
            this.aiSessionId = restoreSessionId;
        }

        // Fires once the backend assigns/confirms the session id (new or restored)
        config.onSessionReady = (sessionId: string) => {
            self.aiSessionId = sessionId;
            self.pushSessionURL(sessionId);
        };

        // Thank-you view after a lead: addressable with thanks=1 on the same chat URL (replaceState, no new history entry).
        // Reload with thanks=1 shows the card again; Back to chat removes the parameter, so a reload shows the normal chat.
        const thanksURL = pageContainer.getAttribute("data-last-url") || "";
        const tq = thanksURL.indexOf("?");
        config.initialThanks = !!restoreSessionId && new URLSearchParams(tq !== -1 ? thanksURL.substring(tq) : "").get("thanks") === "1";
        config.onThanksShown = () => self.setThanksParam(true);
        config.onThanksHidden = () => self.setThanksParam(false);
        config.onNewChat = () => {
            // a new session: same chat page without sessionId and thanks
            const url = new URL(window.location.href);
            url.searchParams.delete("sessionId");
            url.searchParams.delete("thanks");
            window.location.assign(url.toString());
        };
        // Lead completed: go to the site's real thank-you page (same URL as a normal form submission, so analytics fire).
        // assign() keeps the chat in browser history; the page offers "Back to chat" through its chatReturn parameter.
        config.onThankYouRedirect = (url: string) => {
            if (!/^(https?:\/\/|\/)/i.test(url)) return false;
            window.location.assign(url);
            return true;
        };
        // buyer search reached from a form redirect: go straight to the real estate search (the link stays in the chat as a fallback)
        config.onSearchRedirect = (url: string) => {
            window.open(url, "_top");
        };

        config.onPromptCallback = (prompt: string) => prompt;
        config.onText = (data: string): string => data;
        config.onJSON = (data: any) => {};
        config.onXML = (data: string) => {};

        config.onHistoryLoaded = (messages: any[]) => {
            // renderHistoryMessages leaves stale loading dots behind; strip them.
            $(".aifcChatLoadingDots", self.zidx.peakidxShadowRoot).remove();
            $(self.zidx.peakidxShadowRoot).find("#aifcCurrentLoader").remove();

            // RAG chat has no results grid to replay, so nothing else to do here —
            // unlike AISearchIntegration which has to re-run the property search.
        };

        config.onDataCompleteCallback = () => {};

        // Optional "AI Overview" + Google-style search results panel (ai_bot_show_search_results)
        if (pageMarginContainer.getAttribute("data-show-search-results") === "1") {
            config.overviewLabel = pageMarginContainer.getAttribute("data-overview-label") || "AI Overview";
            config.overviewCollapse = pageMarginContainer.getAttribute("data-overview-collapse") !== "0";
            // the panel is a sibling below the chat embed (thread + prompt field)
            const panel = document.createElement("div");
            panel.className = "idx-ai-results";
            panel.style.display = "none";
            chatEmbed.parentElement!.insertBefore(panel, chatEmbed.nextSibling);
            const results = new RAGResults(this.zidx, panel, config.aiBotId, () => self.aiSessionId);
            config.onSearchQuery = (query: string) => results.show(query);
            const baseHistoryLoaded = config.onHistoryLoaded;
            config.onHistoryLoaded = (messages: any[]) => {
                baseHistoryLoaded(messages);
                // restore the last search of the conversation (page 1), no LLM call needed
                for (let i = messages.length - 1; i >= 0; i--) {
                    const m = messages[i];
                    if (m.role === "assistant" && m.toolInput) {
                        results.show(String(m.toolInput));
                        break;
                    }
                }
            };
        }

        // Listing search links from the Jev gate (aiSearchText) leave the chat: the embed is an iframe, so
        // navigate the top window (HubSpot parent page, WordPress page) instead of opening a new tab.
        chatEmbed.addEventListener("click", (e: Event) => {
            const anchor = (e.target as HTMLElement).closest?.("a") as HTMLAnchorElement | null;
            if (!anchor) return;
            const isSearchLink = /[?&]aiSearchText=/.test(anchor.href) || anchor.classList.contains("idx-ai-thanks-search");
            if (!isSearchLink) return;
            e.preventDefault();
            window.open(anchor.href, "_top");
        });

        this.aiChatBox = new AIChatBox(this.zidx, config, this.zidx.peakidxShadowRoot, chatEmbed, function() {
            // session is ready: the server takes the hand-off on this first message (so a reload does not send it again)
            if (autoSend && self.aiChatBox) self.aiChatBox.sendPrompt(autoSend);
        });
        console.log("aiChatBox", config, chatEmbed);
    }

    /**
     * Custom skins draw their own close button. It is only shown when the embedding page confirms it can
     * close the modal: the parent sends {source:"peakidx-embed", type:"hello"} when the iframe loads, and the
     * chat replies {source:"peakidx-chat", type:"custom-close"} so the parent hides its own close button.
     * Parents that never send "hello" (old embeds, standalone visits) keep their own behavior.
     */
    private initEmbedCloseHandshake(pageContainer: HTMLElement) {
        if (window.parent === window) return;
        const closeButton = $(".idx-ai-close", pageContainer)[0] as HTMLElement | undefined;
        if (!closeButton) return;
        closeButton.addEventListener("click", (e) => {
            e.preventDefault();
            postToParent({source: "peakidx-chat", type: "close"});
        });
        window.addEventListener("message", (event: MessageEvent) => {
            if (!acceptParentMessage(event)) return;
            const data = event.data;
            if (!data || data.source !== "peakidx-embed" || data.type !== "hello") return;
            pageContainer.classList.add("idx-ai-has-close");
            postToParent({source: "peakidx-chat", type: "custom-close"});
        });
        // The parent may have sent "hello" before this listener existed, so ask for it again.
        postToParent({source: "peakidx-chat", type: "ready"});
    }

    private getSessionIdFromContainer(pageContainer: HTMLElement): string | null {
        // During SPA navigation, window.location is NOT yet updated when render() runs
        // (pushState fires afterward in a setTimeout inside renderResponse). The URL the
        // SPA is loading is on the active container's data-last-url, set before render().
        const lastURL = pageContainer.getAttribute("data-last-url") || "";
        const qIdx = lastURL.indexOf("?");
        // If data-last-url has no query string, there is genuinely no sessionId —
        // do NOT fall back to window.location.search, that's the stale value.
        const search = qIdx !== -1 ? lastURL.substring(qIdx) : "";

        const fromQuery = new URLSearchParams(search).get("sessionId");
        if (fromQuery && /^[a-zA-Z0-9_-]+$/.test(fromQuery)) {
            return fromQuery;
        }
        return null;
    }

    private setThanksParam(on: boolean) {
        try {
            const url = new URL(window.location.href);
            if (on) url.searchParams.set("thanks", "1"); else url.searchParams.delete("thanks");
            window.history.replaceState(window.history.state, "", url.pathname + url.search + url.hash);
        } catch (e) {
            // address bar update is best effort
        }
    }

    private pushSessionURL(sessionId: string) {
        if (!this.pageContainer
            || !this.pageContainer.classList.contains("zidxPageActive")
            || !(this.zidx.peakidxShadowRoot as ParentNode).contains(this.pageContainer)) {
            return;
        }
        const lastURL = this.pageContainer.getAttribute("data-last-url") || "";
        const url = new URL(this.zidx.options.siteDomain+lastURL);
        if (url.searchParams.get("sessionId") === sessionId) return;
        url.searchParams.set("sessionId", sessionId);
        // lastURL is root-relative; keep the site prefix (wordpress proxy, cdn) in the browser address
        window.history.replaceState({ ragChatSession: sessionId }, "", this.zidx.getPrefixURL(url.pathname) + url.search + url.hash);
    }
}
